import { render, staticRenderFns } from "./StaffRating.vue?vue&type=template&id=2ad69321"
import script from "./StaffRating.vue?vue&type=script&lang=js"
export * from "./StaffRating.vue?vue&type=script&lang=js"
import style0 from "./StaffRating.vue?vue&type=style&index=0&id=2ad69321&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports